export enum ContractorInputName {
  ContractorName = 'contractor_name',
  SalespersonName = 'salesperson_name',
  AgreeToDocuments = 'agree_to_documents',
  ContractorAutofillUsed = 'contractor_autofill_used',
}
